import CustomCantidadRecibidaInput from "@/shared/components/ui/CustomCantidadRecibidaInput";
//import CustomPrecioInput from "@/shared/components/ui/CustomPrecioInputProps";
import { MaterialTransferido } from "@/shared/interfaces";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";

const useRevisionOrdenCompra = () => {
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  //const productos = useCargarSeriesProductos(s => s.productos)
  //console.log('productos', productos)
  //funcion calcular
  /* const updateDetailsProducto = (producto: any) => {
    const cantidad = Number(producto.cantidad_aprobada ?? 0)
    const precio = Number(producto.precio_compra ?? 0)
    const descuento = Number(producto.descuento ?? 0)
    const precio_total = cantidad * precio;
    const subtotal_descuento = precio_total - descuento
    return {
      precio_total: Number(precio_total.toFixed(2)),
      subtotal_descuento: subtotal_descuento.toFixed(2)
    }

  } */
  //console.log('producrtos', productos)
  const infoProductos = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'cantidad',
      header: 'Cant. Aprobada Compra',
      //size: 200
      //size: ,


    },
    {
      accessorKey: 'cantidad_aprobada',
      header: 'Cant. A Comprar',
      size: 80,
      Cell: ({ row }) => {
        const cantidadMaxima = Number(row.original.cantidad)
        return <CustomCantidadRecibidaInput
          value={Number(row.original.cantidad) || 0}
          maxValue={cantidadMaxima}
          handleValue={(value) => {
            /*   const newCantidad = { cantidad_aprobada: value }
              const recalculado = updateDetailsProducto({ ...row.original, ...newCantidad })
              handleActualizarProducto(row.original.id, { ...newCantidad, ...recalculado }) */
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad_aprobada: value
            })
          }}
          row={row}
        />
      }
    },
    {
      accessorKey: 'precio_compra',
      header: 'Precio Unitario',
      size: 80,
      Cell: ({ row }) => {
        return `$${row.original?.precio_compra}`
      }
      /* Cell: ({ row }) => (
        <CustomPrecioInput<MaterialTransferido>
          value={row.original.precio_compra!}
          handleValue={(value) => {
            /* const newCantidad = { precio_compra: value }
            const recalculado = updateDetailsProducto({ ...row.original, ...newCantidad })
            handleActualizarProducto(row.original.id, { ...newCantidad, ...recalculado }) */
      /* handleActualizarProducto(row.original.id, {
        ...row.original,
        precio_compra: value
      }) */
      /*}}
      row={row}
    />
  ) */

    },

    {
      accessorKey: 'precio_total',
      header: 'Subtotal sin descuento',
      //header: 'Precio Total',
      size: 80,
      Cell: ({ row }) => {
        return `$${row.original?.precio_total}`
      }
    },
    {
      accessorKey: 'Descuento',
      header: 'descuento',
      Cell: ({ row }) => {
        return `$${row.original?.descuento}`
      }
    },
    {
      accessorKey: 'subtotal_descuento',
      header: 'Subtotal con descuento'
    },
    {
      accessorKey: 'descripcion',
      header: 'Descripción',
      Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',
    },
    {
      accessorKey: 'codigo',
      header: 'Código',
      size: 80,
      Cell: ({ row }) => row.original?.codigo || 'N/A',
    },
    {
      accessorKey: 'producto_data.unidad_medida',
      header: 'Unidad Medida',
      size: 80,
      Cell: ({ row }) => row.original?.producto_data?.unidad_medida || 'N/A'
    },
    {
      accessorKey: 'producto_data.modelo_producto',
      header: 'Modelo',
      size: 80,
      Cell: ({ row }) => row.original?.producto_data?.modelo_producto || 'N/A'
    },
    {
      accessorKey: 'producto_data.marca_producto',
      header: 'Marca',
      size: 80,
      Cell: ({ row }) => row.original?.producto_data?.marca_producto || 'N/A'
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 80,
    },
  ], [])
  return {
    infoProductos
  }

}
export default useRevisionOrdenCompra;